<div class="font-weight-bold d-flex" *ngIf="subscription">
  <div>[{{subscription.appliance_id}}]</div><div class="ml-1">{{subscription.name}}</div>
</div>
